import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// Wait only for the exact store window to accept the code. A timeout is not authorization.
const OPENER_ACK_TIMEOUT_MS = 2000;

@Component({
    template: `<h3>{{ message }}</h3>`
})
export class AccountConnectedComponent implements OnDestroy {
    message = 'Authorization received. Return to the store window to check whether it was saved.';
    private ackTimer: ReturnType<typeof setTimeout>;
    private ackListener: (event: MessageEvent) => void;

    constructor(private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {
            this.stopWaitingForAck();
            const authCode = params['code'];
            const state = params['state'];
            if (!authCode) return;

            if (params['app_key']) {
                this.handleTemuCallback(authCode, state);
                return;
            }

            window.opener?.postMessage({
                type: 'AUTH_CODE',
                code: authCode,
                state
            }, window.location.origin);
            setTimeout(() => window.close(), 500);
        });
    }

    ngOnDestroy(): void {
        this.stopWaitingForAck();
    }

    private handleTemuCallback(code: string, state: string) {
        const opener: Window = window.opener;
        if (!opener || opener.closed) {
            this.requestStoreAuthorization();
            return;
        }

        this.message = 'Authorization received. Sending it to the store window...';
        this.ackListener = (event: MessageEvent) => {
            const data = event.data;
            if (event.origin !== window.location.origin || event.source !== opener ||
                data?.type !== 'AUTH_CODE_ACK' || data.code !== code) return;
            this.stopWaitingForAck();
            this.message = 'Authorization sent to the store window. Check that window to confirm it was saved.';
            setTimeout(() => window.close(), 500);
        };
        window.addEventListener('message', this.ackListener);
        this.ackTimer = setTimeout(() => {
            this.stopWaitingForAck();
            this.requestStoreAuthorization();
        }, OPENER_ACK_TIMEOUT_MS);
        opener.postMessage({ type: 'AUTH_CODE', code, state }, window.location.origin);
    }

    private stopWaitingForAck() {
        clearTimeout(this.ackTimer);
        if (this.ackListener) window.removeEventListener('message', this.ackListener);
        this.ackListener = null;
    }

    private requestStoreAuthorization() {
        // Query parameters identify neither an intended store nor an authorization attempt.
        // Never guess a store or bypass the modal's rejection by exchanging the code here.
        this.message = 'Authorization could not be matched to an active Temu store window. Return to Settings > Selling Channels and authorize the intended store again.';
    }
}
